import o from "./index198.js";
/* empty css         */
import p from "./index130.js";
const e = /* @__PURE__ */ p(o, [["__scopeId", "data-v-53008d63"]]);
export {
  e as default
};
